import React, { FC, useRef } from "react";
import type { EcosystemNextPagesProps } from "@/types";
import { A11y } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "../link";
import Image from "next/image";
import { useInView } from "@/hooks/reveal-in-view";

export const EcosystemNextPages: FC<EcosystemNextPagesProps> = ({
  nextPages,
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <section className="ecosystemNextPages">
      <div className="wrapper wrapper_lg" ref={ref}>
        <Swiper
          modules={[A11y]}
          spaceBetween={8}
          slidesPerView={1.1}
          breakpoints={{
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
          }}
          grabCursor
          className="ecosystemNextPages--swiper"
        >
          {nextPages.map((slide, index) => {
            return (
              <SwiperSlide
                key={index}
                className="ecosystemNextPages--slide"
                style={{
                  transform: isInView
                    ? "none"
                    : `translateY(${20 * (index + 1)}px)`,
                  opacity: isInView ? 1 : 0,
                  transition: `all 0.5s cubic-bezier(0.17, 0.55, 0.55, 1) ${
                    index * 0.1
                  }s`,
                }}
              >
                <Link
                  href={slide.entry}
                  noStyle
                  className="ecosystemNextPages--slide-link"
                  onMouseEnter={(event) => {
                    const target = event.currentTarget as HTMLElement;

                    if (target) {
                      target
                        .querySelector(
                          ".ecosystemNextPages--slide-titleWrapper svg"
                        )
                        ?.classList.add("hover-animation-bounce-horizontal");
                    }
                  }}
                >
                  <div className="ecosystemNextPages--slide-subtitle">
                    {slide.subtitle}
                  </div>
                  <div className="ecosystemNextPages--slide-titleWrapper">
                    <div
                      className="ecosystemNextPages--slide-title"
                      data-title={slide.title}
                    >
                      <span>{slide.title}</span>
                    </div>
                    <svg
                      width="46"
                      height="14"
                      viewBox="0 0 46 14"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      onAnimationEnd={(event) => {
                        const target = event.target as HTMLElement;
                        target.classList.remove(
                          "hover-animation-bounce-horizontal"
                        );
                      }}
                    >
                      <path d="M39 0L46 7L39 14" fill="currentColor" />
                      <path
                        d="M0 7L39 7"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <Image
                    src="/images/spiral-2-blue.webp"
                    alt="Spiral"
                    width={1195}
                    height={1467}
                    draggable={false}
                    className="ecosystemNextPages--slide-spiral"
                    sizes="(max-width: 1023px) 100vw, 1023px"
                  />
                </Link>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
};
